import {
  Box,
  Button,
  Card,
  Checkbox,
  CrudMode,
  DataArray,
  DataDisplay,
  formatBoolean,
  Grid,
  GridBreak,
  pn,
  Stack,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input, Select } from "components";
import {
  TestType,
  TestTypeEditResource,
  TestTypeViewResource,
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const BasicInfo = (props: {
  crudMode: CrudMode;
  testType: TestType;
  setTestType: (value: TestType) => void;
  viewResource: TestTypeViewResource;
  editResource: TestTypeEditResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints, fullFieldBreakpoints } =
    useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const nameField = () => {
    const propertyName = pn<TestType>("name");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.testType.name}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.testType.name}
        onChange={(e) =>
          props.setTestType(
            produce(props.testType, (draft) => {
              draft.name = e.target.value;
            })
          )
        }
      />
    );
  };

  const testTypeGroupField = () => {
    const propertyName = pn<TestType>("testTypeGroupId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.testType.testTypeGroup?.name}</DataDisplay>
    ) : (
          <Select
            modelProperty={property}
            errors={props.validationErrors[propertyName]}
            value={props.editResource.testTypeGroups?.find((x) => x.id === props.testType.testTypeGroupId)}
            options={props.editResource.testTypeGroups}
            getOptionLabel={(option) => option.name}
            onChange={(e, value) =>
              props.setTestType(
                produce(props.testType, (draft) => {
                  draft.testTypeGroupId = value?.id;
                })
              )
            }
          />
    );
  };

    const aprTestTypeField = () => {
    const propertyName = pn<TestType>("aprTestTypeId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.testType.aprTestType?.name}</DataDisplay>
    ) : (
          <Select
            modelProperty={property}
            errors={props.validationErrors[propertyName]}
            value={props.editResource.aprCategories?.find((x) => x.id === props.testType.aprTestTypeId)}
            options={props.editResource.aprCategories}
            getOptionLabel={(option) => option.name}
            onChange={(e, value) =>
              props.setTestType(
                produce(props.testType, (draft) => {
                  draft.aprTestTypeId = value?.id;
                })
              )
            }
          />
    );
  };

  return (
    <Card>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={largeFieldBreakpoints}>
          {nameField()}
        </Grid>

        <Grid item xs={largeFieldBreakpoints}>
          {testTypeGroupField()}
        </Grid>

        <Grid item xs={largeFieldBreakpoints}>
          {aprTestTypeField()}
        </Grid>
      </Grid>
    </Card>
  );
};
